module.exports = __webpack_public_path__ + "static/media/google-play-badge-pl.8707630b.png";